module.exports = __webpack_public_path__ + "img/craftBannerWhirlpool.b86abf9.webp";